/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, Card, Item, Placeholder } from "semantic-ui-react";
import { PromotionCampaignStatusLabel } from "../CampaignStatus/CampaignStatus";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom-v5-compat";
import { useMutation } from "@tanstack/react-query";
import { exportCampaignSales } from "../../../../services/PromotionCampaign/PromotionCampaign.service";
import { notify } from "react-notify-toast";
import { downloadRemoteFile } from "../../../../services/File/File.service";


export const PromotionCampaignCard = ({ campaign, isActive = false, compact= false}) => {
  const { t } = useTranslation();
  const location = useLocation();

  const exportCampaignMutation = useMutation({
    mutationFn: async (campaign) => {
      return exportCampaignSales(campaign.id);
    },
    onSuccess: (response) => {
      if (response.status === "generating") {
        notify.show(t("promotion_campaign.export_in_progress"), "info");
      } else if (response.status === "ready") {
        notify.show(t("promotion_campaign.export_ready"), "success");
        downloadRemoteFile(response.url, response.fileName);
      }
    },
    onError: (error) => {
      notify.show(t("global.anErrorOccurred"), "error");
    },
  });

  const dateStyle = {
                day: "2-digit",
                month: compact ? "short" : "long",
                ...(compact ? {} : {year: "numeric"}),
  }

  return (
    <Item
      css={css`
        position: relative;
        padding-top: 1em !important;
        padding-left:0.5em!important;
        ${isActive
          ? "margin-right:1.2em!important;"
          : undefined}
        ${(compact  && !isActive) ? "background-color:rgba(240,240,240,0.5)!important;" : ""}
        ${(compact  && isActive) ? "padding-top: 2em !important;": ""}
        display: flex;
        flex-direction: column;
      `}
      style={isActive && compact ? {paddingTop: "2em !important;"} : {}}
      key={campaign.id}
    >
      <Item.Content
        css={css`
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
        `}
      >
          <Item.Meta style={compact ? {marginBottom:"1.2em"} : {}}>
          <span >
            {t("promotion_campaign.from_x_to_y", {
              start: new Date(campaign.start).toLocaleDateString(undefined, dateStyle),
              end: new Date(campaign.end).toLocaleDateString(undefined, dateStyle),
            })}
          </span>
            <div style={{ position: "absolute", top: 10, right: 20 }}>
            <PromotionCampaignStatusLabel status={campaign.status} />
          </div>
        </Item.Meta>
       
        <Item.Header>
          {campaign.name}
         
        </Item.Header>

      
        <Item.Description
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
          }}
        >
            <div>
            <strong>Platformes :</strong>{" "}
            {campaign.platforms?.map((p) => p.name).join(", ") || "-"}
          </div>
          <div>
            <strong>Promotions :</strong>{" "}
            {campaign.promotions?.filter((p) => p.status !== "DISABLED").length ||
                0}
          </div>
          {campaign.budget && (
            <div>
              <br />
              <strong>Budget :</strong> {campaign.budget ?? "-"}
            </div>
          )}
          {!compact && (<div style={{ position: "absolute", top: 0, right: 18 }}>
          
            {campaign.status === "COMPLETED" && (
              <Button
                size="tiny"
                loading={exportCampaignMutation.isPending}
                onClick={() => exportCampaignMutation.mutate(campaign)}
                color="grey"
                basic
              >
                {t("promotion_campaign.export", "Export")}
              </Button>
            )}
              {!isActive ? (
              <Button
                as={Link}
                size="tiny"
                to={`/categories/promotion-campaigns/${campaign.id}${location.search}`}
                color="teal"
              >
                {t("promotion_campaign.see", "Voir")}
              </Button>
            ) : (
              <div style={{ display: "inline-flex" }}></div>
            )}
          </div>)}

        </Item.Description>

        {compact && (<Item.Extra extra>
            {campaign.status === "COMPLETED" && (
              <Button
                size="tiny"
                loading={exportCampaignMutation.isPending}
                onClick={() => exportCampaignMutation.mutate(campaign)}
                color="grey"
                basic
              >
                {t("promotion_campaign.export", "Export")}
              </Button>
            )}
              {!isActive ? (
              <Button
                as={Link}
                size="tiny"
                to={`/categories/promotion-campaigns/${campaign.id}${location.search}`}
                color="teal"
              >
                {t("promotion_campaign.see", "Voir")}
              </Button>
            ) : (
              <div style={{ display: "inline-flex" }}></div>
            )}
        </Item.Extra>)}
      </Item.Content>
    </Item>
  );
};

export const PromotionCampaignCardPlaceholder = () => (
  <Card
    css={css`
      padding-top: 1em !important;
      display: flex;
      flex-direction: column;
    `}
    key={"loading-pc-list"}
  >
    <Card.Content
      css={css`
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
      `}
    >
      <Placeholder>
        <Placeholder.Header>
          <Placeholder.Line length="very short" />
          <Placeholder.Line length="medium" />
        </Placeholder.Header>
        <Placeholder.Paragraph>
          <Placeholder.Line length="short" />
        </Placeholder.Paragraph>
      </Placeholder>
    </Card.Content>
    <Card.Content extra>
      <Placeholder>
        <Placeholder.Line length="short" />
      </Placeholder>
    </Card.Content>
  </Card>
);
